class ProductAdjust {
	constructor() {
		this.init();
	}

	init() {
		this.reorderModules();
	}

	reorderModules() {
		if (window.innerWidth <= 767) {
			const nutritionalInfo = document.querySelector(
				'.block-columns .block-nutritional-info'
			);

			if (nutritionalInfo) {
				const nutritionalWrapper = nutritionalInfo.closest('.block-columns');

				if (nutritionalWrapper) {
					let iconWithText = nutritionalWrapper.querySelector('.block-icon-with-text');

					if (iconWithText) {
						const previousElement = iconWithText.previousElementSibling;

						if (
							previousElement &&
							previousElement.classList.contains('wp-block-heading')
						) {
							iconWithText = previousElement;
						}

						nutritionalInfo.parentNode?.removeChild(nutritionalInfo);

						iconWithText.parentNode?.insertBefore(nutritionalInfo, iconWithText);
					}
				}
			}
		}
	}
}

new ProductAdjust();
